'use client';
import React from 'react';

export default function ServicesSection() {
  const services = [
    {
      title: 'Individual Therapy',
      description: 'I offer highly personalised, formulation-led psychological therapy tailored to your individual needs. My integrative approach draws on Cognitive Behavioural Therapy (CBT), Dialectical Behaviour Therapy (DBT), Compassion Focused Therapy (CFT), Cognitive Analytic Therapy (CAT), and Psychodynamic approaches, adapting flexibly to each person rather than a fixed therapeutic model. Every course of therapy begins with a comprehensive psychological formulation, ensuring that treatment is guided by a deep understanding of your experiences, strengths and goals.',
      link: '/services',
    },
    {
      title: 'Specialist Psychological Assessment',
      description: 'I provide a comprehensive range of neuro assessments for a variety of issues including ADHD, cognitive ability, personality functioning, trauma-related difficulties, dementia and memory concerns, and mental capacity. I also have specialist training in a range of neuropsychological and neurological-style assessments. I also undertake medico-legal assessments within the family court system, providing independent expert opinion to assist legal decision-making. Assessments can be offered as part of a broader therapeutic or consultative package, or as a standalone service.',
      link: '/services',
    },
    {
      title: 'Clinical Supervision',
      description: 'I offer reflective, formulation-led supervision for psychologists and health professionals across NHS, independent and private practice settings. Supervision focuses on developing clinical judgement, psychological formulation, and confidence in working with complex presentations.',
      link: '/services',
    },
    {
      title: 'Training & Consultancy',
      description: 'I provide bespoke training, workshops and consultancy for health professionals, leadership teams and corporate organisations. This includes one-off training sessions or tailored programmes addressing specific clinical or organisational needs. My consultancy approach is formulation-led and designed to support wellbeing, communication, leadership and performance in high-demand environments.',
      link: '/services',
    },
    {
      title: 'Concierge-style approach',
      description: 'I offer a discreet, bespoke concierge-style service for individuals seeking highly personalised psychological care delivered with flexibility, continuity and discretion. This may include flexible scheduling, support between sessions where appropriate, and collaboration with other professionals involved in your care.',
      link: '/services',
    },
  ];

  return (
    <section
      className="w-full"
      style={{ backgroundColor: '#E8D8D5', paddingTop: 'clamp(64px, 8vw, 112px)', paddingBottom: 'clamp(64px, 8vw, 112px)' }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(24px, 4vw, 64px)' }}>

        {/* Header */}
        <div
          className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6"
          style={{ marginBottom: 'clamp(40px, 5vw, 64px)' }}
        >
          <div>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '11px',
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: '#8A9E8C',
                marginBottom: '12px',
              }}
            >
              Professional Services
            </p>
            <h2
              style={{
                fontFamily: 'orpheus-pro, Georgia, serif',
                fontSize: 'clamp(26px, 3.2vw, 48px)',
                fontWeight: '400',
                color: '#1A2332',
                lineHeight: '1.2',
              }}
            >
              Bespoke Psychological Services
            </h2>
          </div>
          <a
            href="/services"
            style={{
              fontFamily: 'adobe-garamond-pro, Georgia, serif',
              fontSize: '13px',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: '#1A2332',
              textDecoration: 'none',
              borderBottom: '1px solid rgba(26,35,50,0.35)',
              paddingBottom: '2px',
              flexShrink: 0,
              transition: 'border-color 0.2s ease',
            }}
            onMouseEnter={e => ((e.currentTarget as HTMLElement).style.borderBottomColor = '#1A2332')}
            onMouseLeave={e => ((e.currentTarget as HTMLElement).style.borderBottomColor = 'rgba(26,35,50,0.35)')}
          >
            View all services →
          </a>
        </div>

        {/* Editorial service list */}
        <div style={{ borderTop: '1px solid rgba(26,35,50,0.12)' }}>
          {services.map((service, idx) => (
            <a
              key={idx}
              href={service.link}
              style={{ textDecoration: 'none', display: 'block' }}
            >
              <div
                className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-12 group"
                style={{
                  padding: 'clamp(24px, 3vw, 36px) 0',
                  borderBottom: '1px solid rgba(26,35,50,0.12)',
                  transition: 'padding-left 0.2s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={e => ((e.currentTarget as HTMLElement).style.paddingLeft = '12px')}
                onMouseLeave={e => ((e.currentTarget as HTMLElement).style.paddingLeft = '0')}
              >
                {/* Title */}
                <h3
                  style={{
                    fontFamily: 'orpheus-pro, Georgia, serif',
                    fontSize: 'clamp(18px, 2vw, 28px)',
                    fontWeight: '400',
                    color: '#1A2332',
                    lineHeight: '1.3',
                    flexShrink: 0,
                    minWidth: '220px',
                    maxWidth: '260px',
                    transition: 'color 0.2s ease',
                  }}
                >
                  {service.title}
                </h3>

                {/* Description */}
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: 'clamp(15px, 1.2vw, 17px)',
                    color: '#4A4A4A',
                    lineHeight: '1.7',
                    flex: 1,
                  }}
                >
                  {service.description}
                </p>

                {/* Arrow */}
                <span
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: '20px',
                    color: 'rgba(26,35,50,0.3)',
                    flexShrink: 0,
                    transition: 'color 0.2s ease, transform 0.2s ease',
                  }}
                >
                  →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}